define.alias("shared/components/shared/ui/accordion", "settings/components/shared/ui/accordion");